import PropTypes from 'prop-types';
import * as React from 'react';
import { useStepIndicatorContext } from './step-indicator-context.js';
import { classNames } from '../../../core/utilities/classnames.utils.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

var propTypes = {
  /**
  * Number of the step
  */
  stepNumber: PropTypes.number.isRequired
};
var propKeysToRemove = Object.keys(propTypes);
var StepIndicatorStep = renderWithRef('StepIndicatorStep', propTypes, function (props, ref) {
  var _useStepIndicatorCont = useStepIndicatorContext(),
      currentStepNumber = _useStepIndicatorCont.currentStepNumber;

  var stepNumber = props.stepNumber,
      children = props.children;
  var className = classNames(new Set(['swan-step']), {
    'swan-step-past': stepNumber < currentStepNumber,
    'swan-step-previous': stepNumber === currentStepNumber - 1,
    'swan-step-current': stepNumber === currentStepNumber,
    'swan-step-next': stepNumber === currentStepNumber + 1,
    'swan-step-future': stepNumber > currentStepNumber
  });
  return /*#__PURE__*/React.createElement(RenderComp, {
    root: "li",
    forwardedRef: ref,
    propKeysToRemove: propKeysToRemove,
    classNames: className,
    props: _object_spread({}, props, stepNumber === currentStepNumber ? {
      'aria-current': 'step'
    } : {})
  }, children);
});
StepIndicatorStep.defaultProps = {
  stepNumber: 1
};
export { StepIndicatorStep };